export class PaymentType {

  static readonly PREPAYMENT = 'pre';
  static readonly FINAL_PAYMENT = 'final';
  static readonly PAID_DIRECT = 'direct';
  static readonly EVENT_CANCELLED = 'cancelled';

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/payment-type.ts